import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Paginator } from '@els/els-react--paginator';
import { sizeChunckOfGroupsNewAuthorSearchFilter } from '@Containers/ResultsFilters/ResultsFiltersComponents/BarChartCheckboxesDialog/BarChartCheckboxesDialogConstants';
import GoToPage from '@Containers/ResultsFilters/ResultsFiltersComponents/NewAuthorCheckboxesDialog/Components/GoToPage';

function Pagination({ id, chunksCount, setActiveChunkId, activeChunkIndexAsInteger, onClickGoToButton, filter }) {
  return (
    <div className="new-author-checkboxes-dialog__pagination">
      <Paginator
        onPageChange={(page) => {
          setActiveChunkId(id, page - 1);
        }}
        resultsPerPage={sizeChunckOfGroupsNewAuthorSearchFilter}
        totalResults={filter.get('groupCount')}
        currentPage={activeChunkIndexAsInteger + 1}
        shouldShowFirstLastButton
        maxPagesToShow={3}
        a11y={{ name: 'Search results', pagingUnitName: 'Page', morePagingUnit: 'More pages' }}
      />
      <GoToPage chunksCount={chunksCount} onClick={onClickGoToButton} />
    </div>
  );
}

Pagination.propTypes = {
  id: PropTypes.string.isRequired,
  chunksCount: PropTypes.number,
  setActiveChunkId: PropTypes.func.isRequired,
  activeChunkIndexAsInteger: PropTypes.number.isRequired,
  onClickGoToButton: PropTypes.func.isRequired,
  filter: PropTypes.instanceOf(Map),
};

export default Pagination;
